/**
 * Theme override for MUI Avatar component.
 * Use this file to customize the default styles and props for Avatar across the application.
 */
import { ThemeOptions } from '@mui/material';

export const MuiAvatar: ThemeOptions['components']['MuiAvatar'] = {
  styleOverrides: {
    root: {
      height: 32,
      width: 32,
      fontSize: 16
    }
  },
  defaultProps: {}
};
